import type { DocumentInfo } from "@mirage/service-conversation/types";

export const convertSuggestionSourceToDocumentInfo = (uuid: string) => {
  const documentInfo: DocumentInfo = {
    uuid,
    url: "",
    title: "",
    lastUpdatedMs: 0,
    brandedType: "",
    body: "",
    ownerId: "",
    thirdPartyId: "",
    relevanceScore: 0,
    index: "",
    channel: {
      id: "",
      name: "",
      url: "",
      created_at_ms: 0,
      type: { ".tag": "channel_type_unset" },
    },
    inclusionType: "suggestion",
  };

  // TODO [BFD-1337]: remove this once we have a better way to handle fss files
  const isFssFile = uuid.startsWith("id:");
  if (isFssFile) {
    documentInfo.fssRetrieverInfo = {
      fssFileIdentifier: {
        fileId: uuid,
      },
    };
  }

  return documentInfo;
};
